import {config} from '@/env-config';

export const VALUE_RESOURCE = config.valueApiHost;
export const CRM_RESOURCE = config.crmApiHost;

const SCOPES_BY_RESOURCE: Record<string, string> = {
    [VALUE_RESOURCE]: 'openid read:groups read:stores read:roles read:user write:groups read:permissions write:permissions write:assignments read:datasets write:datasets delete:datasets read:config write:config',
    [CRM_RESOURCE]: 'read write',
};

export function scopesFor(resource: string): string {
    const scopes = SCOPES_BY_RESOURCE[resource];
    if (!scopes) {
        throw new Error(`No scopes registered for resource: ${resource}`);
    }
    return scopes;
}
